export const DAILY_TASK_USER_KEY_PREFIX = 'daily_task:user:';
export const DAILY_TASK_ALL_KEY = 'daily_task:all';

export const isDailyTaskView = view =>
  !!view?.system && String(view?.system_key || '').startsWith('daily_task:');

export const dailyTaskSystemKeyFor = userId =>
  `${DAILY_TASK_USER_KEY_PREFIX}${userId}`;

export const dailyTaskUserIdFromView = view => {
  const key = String(view?.system_key || '');
  if (key === DAILY_TASK_ALL_KEY) return 'all';
  if (!key.startsWith(DAILY_TASK_USER_KEY_PREFIX)) return null;
  return key.slice(DAILY_TASK_USER_KEY_PREFIX.length) || null;
};

export const findDailyTaskView = (views, userId) => {
  const systemKey =
    userId === 'all' || userId === 'true'
      ? DAILY_TASK_ALL_KEY
      : dailyTaskSystemKeyFor(userId);
  return (views || []).find(view => view.system_key === systemKey);
};
